import { getCurrencySymbol } from "@hl/shared-features/lib/utils/currency";

import { useCreateCollectionFormContext } from "~/features/collections/forms/CreateCollectionMultistepForm/context";

const useCurrencyDisplay = () => {
  const form = useCreateCollectionFormContext();
  const formValues = form.values;

  const displayCurrency = getCurrencySymbol(
    formValues.collection.chainId,
    false,
    formValues.distribution.currency
  );

  return {
    displayCurrency,
  };
};

export default useCurrencyDisplay;
export type UseCurrencyDisplay = ReturnType<typeof useCurrencyDisplay>;
